import { SET_ACTIVE_FACILITY } from "../actions/facility/types";
import { QueryClient } from "react-query";
const INITIAL_STATE = { code: "yyz1", service_area: "yyz" };
export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_ACTIVE_FACILITY:
      return action.data;
    default:
      return state;
  }
}
